import React, { Component } from "react";
import ListGroup from "./navListGroup";
import { navLinks } from "../services/navLinkService";

class SideNav extends Component {
  state = {
    links: [],
    selectedLink: null,
  };

  async componentDidMount() {
    this.setState({ links: navLinks, selectedLink: {} });
  }

  handleLinkSelect = (link) => {
    this.setState({ selectedLink: link });
  };

  render() {
    return (
      <aside className="mboss-side-rail" aria-label="Main navigation">
        <nav className="nav-section-list nav-section-list--rail" aria-label="Modules">
          <ListGroup
            items={this.state.links}
            selectedItem={this.state.selectedLink}
            onItemSelect={this.handleLinkSelect}
          />
        </nav>
      </aside>
    );
  }
}

export default SideNav;
